export enum InvoiceAllocationStatuses {
  owing = "Owing",
  writtenOff = "Written-off",
  paid = "Paid",
  cancelled = "Cancelled",
  credited = "Credited"
}
